import React from 'react';
import { Link } from 'react-router';
// import { Row, Col, Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// import * as styles from './StudentPreferences.scss';
const PREFERENCES_LABEL = ['Favorite', 'Great', 'Good', 'Acceptable'];
const formatRank = rankId => PREFERENCES_LABEL[rankId];

class Preferences extends React.Component {
  render() {
    const { preference, runName } = this.props;
    const formatName = (courseSlug, course) => (
      <Link
        className="linkToClass"
        to={`/administer/${runName}/class/${course.id}`}
      >
        {courseSlug}
      </Link>
    );
    return (
      <div ref="courses_preferences">
        <div className="page-subtitle">Class Rankings</div>
        <BootstrapTable
          data={preference}
          bordered={false}
          hover={true}
          condensed={true}
        >
          <TableHeaderColumn
            dataField="slug"
            isKey={true}
            dataSort={true}
            dataFormat={formatName}
            width="10%"
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="longname" width="40%" dataSort={true}>
            Description
          </TableHeaderColumn>
          <TableHeaderColumn dataField="instructor" width="20%" dataSort={true}>
            Instructor
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="weight"
            dataAlign="center"
            dataSort={true}
            width="10%"
          >
            Credits
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="preference_class"
            dataSort={true}
            width="10%"
            dataFormat={formatRank}
          >
            Rank
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default Preferences;



// WEBPACK FOOTER //
// ./src/components/students/StudentPreferences.js